import { api } from '../config'

export const deleteCourseService = async (courseId: string) => {
  await api.delete(`/api/courses/${courseId}`)
}
